import React, { useState, useEffect } from "react";
import Loader from "../../../Common/Loader/loader";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import * as XLSX from "xlsx";
import { Tab, Tabs, TabPanel, TabList } from "react-tabs";
import CustomDataTable from '../../../Common/ReportTable/ReportTable';

const TSSCTPWise = () => {
    const headers = [
        "zone",
        "circle",
        "deployment",
        "reported at ts/sctp",
        "total_trips",
        "trip_1",
        "trip_2",
        "trip_3",
        "trip_4",

    ];
    const [selectedTab, setSelectedTab] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [totalApiDataCount, setTotalApiDataCount] = useState(0); // State variable for total count

    const searchResults = require("../../../Common/Json/scvReport.json");

    useEffect(() => {
        // Update the total count whenever searchResults change
        setTotalApiDataCount(searchResults.length);
    }, [searchResults]);

    useEffect(() => {
        // Simulate loading data
        setIsLoading(true);

        // Assuming you have an asynchronous data fetching process
        fetchData()
            .then(() => setIsLoading(false)) // Once data fetching is done, set isLoading to false
            .catch(error => {
                setIsLoading(false); // Set isLoading to false in case of error
                console.error('Error fetching data:', error);
                // Handle error (e.g., show error message)
            });
    }, []); // Empty dependency array means this effect runs only once on mount

    // Function to simulate asynchronous data fetching
    const fetchData = async () => {
        await new Promise(resolve => setTimeout(resolve, 2000));
    };

    const generatePDF = () => {
        const table = document.getElementById("project-reports");
        if (!table) {
            console.error("Target table element not found.");
            return;
        }

        // Create a new jsPDF instance
        const pdf = new jsPDF("p", "pt", "a4");

        // Capture the entire HTML table
        html2canvas(table).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const imgWidth = 500;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            // Add the image of the entire HTML table to the PDF
            pdf.addImage(imgData, "PNG", 40, 40, imgWidth, imgHeight);

            // Save the PDF
            pdf.save("CumulativeReport.pdf");
        });
    };
    const generateExcel = (searchResults, headers) => {
        const workbook = XLSX.utils.book_new();
        let allData = [];

        // Add a serial number column
        allData.push(["S.No", ...headers]);

        // Convert array of objects to array of arrays for all pages
        searchResults.forEach((item, index) => {
            const rowData = [index + 1, ...headers.map((header) => item[header])];
            allData.push(rowData);
        });

        // Compute totals for each column
        // Compute totals for each column
        const columnTotals = {};
        headers.forEach((header) => {
            // Calculate the total for the current column
            const total = searchResults.reduce((acc, item) => {
                return acc + (item[header] ? parseFloat(item[header]) : 0);
            }, 0);

            // Store the total for the current column if it's not zero
            if (total !== 0) {
                columnTotals[header] = total;
            }
        });

        // Add totals to the data array
        const totalsArray = [
            "Total",
            ...headers.map((header) => columnTotals[header] || ""),
        ];
        allData.push(totalsArray);

        // Create a worksheet for data
        const allWorksheet = XLSX.utils.aoa_to_sheet(allData);

        // Add a blank row between data and totals
        XLSX.utils.sheet_add_json(allWorksheet, [], { origin: -1 });

        // Append the worksheet to the workbook
        XLSX.utils.book_append_sheet(workbook, allWorksheet, "All Data");

        // Save the workbook to a file
        XLSX.writeFile(workbook, "table_data.xlsx");
    };

    const satDeviationColums = [
        {
            name: 'Sl.No',
            selector: (row) => row['slno'],
            sortable: true,
            format: (row, rowIndex) => rowIndex + 1,
        },
        {
            name: 'Zone',
            selector: (row) => row['zone'],
            sortable: true,
        },
        {
            name: 'Circle',
            selector: (row) => row['circle'],
            sortable: true,
        },
        {
            name: 'TS/SCTP',
            selector: (row) => row['TS/SCTP'],
            sortable: true,
        },
        {
            name: 'No.of SATs Reported of TS/SCTP',
            selector: (row) => row['No. of SATs Reported of TS/SCTP'],
            sortable: true,
        },
        {
            name: 'No.of SATs Trip of TS/SCTP',
            selector: (row) => row['No. of SATs Trip of TS/SCTP'],
            sortable: true,
        },
    ]

    return (
        <>
            <div style={{ width: "100%" }}>
                <div className="content">
                    <div className="page-content">
                        <div className="page-header"></div>
                        <div className="row">
                            <div className="col" >
                                <div className="container-fluid pt-3">
                                    <div className="row mb-5">
                                        <div className="col-xl-12 col-md-12">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div class="row mt-5" style={{ textAlign: "justify" }}>
                                                        <div class="col-md-4 mb-2">
                                                            <label htmlFor="fromDate">From Date:</label>
                                                            <input
                                                                type="datetime-local"
                                                                id="fromDate"
                                                                style={{ backgroundColor: "#fff" }}
                                                                className="form-control"
                                                            // value={`${fromDate}T${fromTime}`}
                                                            // onChange={(e) => handleDateTimeChange(e, true)}
                                                            />
                                                        </div>
                                                        <div class="col-md-4 mb-2">
                                                            <label htmlFor="toDate">To Date:</label>
                                                            <input
                                                                type="datetime-local"
                                                                id="toDate"
                                                                style={{ backgroundColor: "#fff" }}
                                                                className="form-control"
                                                            // value={`${toDate}T${toTime}`}
                                                            // onChange={(e) => handleDateTimeChange(e, true)}
                                                            />
                                                        </div>
                                                        <div class="col-md-4 mb-3">
                                                            <label htmlFor="zone">Zones</label>
                                                            <select
                                                                className="form-select"
                                                                style={{ backgroundColor: "#fff" }}
                                                                name="Shift type"
                                                                id="Shift type"
                                                            >
                                                                <option value="">Select Zone </option>
                                                                <option value={"1"}>Charminar</option>
                                                                <option value={"2"}>Khairthabad</option>
                                                                <option value={"3"}>Uppal</option>
                                                                <option value={"4"}>Kukatpally</option>
                                                            </select>
                                                        </div>
                                                        <div className="text-end">
                                                            <button
                                                                onClick={() => generatePDF(searchResults)}
                                                                style={{ marginBottom: "10px" }}
                                                            >
                                                                Download Pdf
                                                            </button>
                                                            <button
                                                                onClick={() => generateExcel(searchResults, headers)}
                                                                style={{ marginBottom: "10px" }}
                                                            >
                                                                Download Excel
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="card mt-2">
                                                        <div className="card-body">
                                                            <div className="top-header">
                                                                <span>
                                                                    {" "}
                                                                    TS/SCTP Wise Reported SATs
                                                                </span>
                                                            </div>
                                                            <CustomDataTable
                                                                columns={satDeviationColums}
                                                                data={searchResults}
                                                                isLoading={isLoading}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {isLoading && <Loader />}
        </>
    );
};

export default TSSCTPWise;
